import React, { useState, useEffect, useRef } from 'react';
import FiltroUsuarios from './components/FiltroUsuarios';
import { useFiltroUsuarios } from './filtroUsuarios';
import BancoAfirme from './components/BancoAfirme';
import BancoBanorte from './components/BancoBanorte';
import BancoSantander from './components/BancoSantander';
import BancoBanregio from './components/BancoBanregio';
import BancoScotiabank from './components/BancoScotiabank';
import BancoBanamex from './components/BancoBanamex';
import BancoHSBC from './components/BancoHSBC';
import StatusProspecto from './components/StatusProspecto';
import { calcularRFC, calcularCURP, esMexico } from './utils/calculoRfcCurp';
import useResponsive from './utils/useResponsive';
import { hoyISO } from './utils/fechaHoy';

const API = '/api';
const ESTADOS_CIVILES = ['Soltero', 'Casado', 'Viudo', 'Union Libre', 'Divorciado', 'Sociedad de Convivencia'];
const REGIMENES_MATRIMONIO = ['Sociedad Conyugal', 'Separación de Bienes'];
const VIVE_EN_CASA_OPCIONES = ['Propia', 'Hipotecada', 'Rentada', 'Padres', 'Otro Parentesco', 'Otro'];

const aMayusMinus = (texto) =>
  (texto || '')
    .toLowerCase()
    .replace(/(^|\s)\S/g, (letra) => letra.toUpperCase());

const getInitialFormData = () => ({
    fecha_solicitud: hoyISO(),
    broker_id: '',
    titular: {
      nombres: '', apellido_paterno: '', apellido_materno: '', fecha_nacimiento: '',
      edad_anos: '', edad_meses: '', pais_nacimiento: 'México', nacionalidad: 'Mexicana',
      entidad_nacimiento: '', municipio_nacimiento: '', lugar_nacimiento_extranjero: '', rfc: '', curp: '', numero_imss: '',
      sexo_genero_id: '', calle: '', no_ext: '', no_int: '', codigo_postal: '',
      colonia: '', ciudad: '', entidad_federativa: '', pais: 'México',
      telefono_casa: '', telefono_celular: '', email: '',
      antiguedad_domicilio_anos: '', antiguedad_domicilio_meses: '',
      antiguedad_domicilio_anterior_anos: '', antiguedad_domicilio_anterior_meses: '',
      numero_identificacion: '', fecha_vigencia_identificacion: '', tipo_identificacion: '', tipo_identificacion_santander_id: '',
      estado_civil: '', regimen_matrimonio: '', vive_en_casa: '',
      estatura_cms: '', estatura_mts: '', peso_kg: '', num_dependientes: '',
      nombre_empresa: '', rfc_empresa: '', trabajo_calle: '', trabajo_no_ext: '', trabajo_no_int: '',
      trabajo_codigo_postal: '', trabajo_colonia: '', trabajo_ciudad: '',
      trabajo_entidad_federativa: '', trabajo_pais: 'México', trabajo_telefono: '', trabajo_extension: '',
      fecha_ingreso_trabajo: '', antiguedad_trabajo_anos: '', antiguedad_trabajo_meses: '',
      antiguedad_trabajo_anterior_anos: '', antiguedad_trabajo_anterior_meses: '',
      nombre_empresa_anterior: '', fecha_ingreso_trabajo_anterior: '',
      fecha_salida_trabajo_anterior: '', nombre_jefe_anterior: '', telefono_trabajo_anterior: '',
      pais_residencia: ''
    },
    coacreditado: {
      es_conyuge: false,
      participa_ingresos: false,
      mismo_domicilio_titular: false,
      nombres: '', apellido_paterno: '', apellido_materno: '', fecha_nacimiento: '',
      edad_anos: '', edad_meses: '', pais_nacimiento: 'México', nacionalidad: 'Mexicana',
      entidad_nacimiento: '', municipio_nacimiento: '', lugar_nacimiento_extranjero: '', rfc: '', curp: '', numero_imss: '',
      sexo_genero_id: '', calle: '', no_ext: '', no_int: '', codigo_postal: '',
      colonia: '', ciudad: '', entidad_federativa: '', pais: 'México',
      telefono_casa: '', telefono_celular: '', email: '',
      antiguedad_domicilio_anos: '', antiguedad_domicilio_meses: '',
      antiguedad_domicilio_anterior_anos: '', antiguedad_domicilio_anterior_meses: '',
      numero_identificacion: '', fecha_vigencia_identificacion: '', tipo_identificacion: '', tipo_identificacion_santander_id: '',
      estado_civil: '', regimen_matrimonio: '', vive_en_casa: '',
      estatura_cms: '', estatura_mts: '', peso_kg: '', num_dependientes: '',
      nombre_empresa: '', rfc_empresa: '', trabajo_calle: '', trabajo_no_ext: '', trabajo_no_int: '',
      trabajo_codigo_postal: '', trabajo_colonia: '', trabajo_ciudad: '',
      trabajo_entidad_federativa: '', trabajo_pais: 'México', trabajo_telefono: '', trabajo_extension: '',
      fecha_ingreso_trabajo: '', antiguedad_trabajo_anos: '', antiguedad_trabajo_meses: '',
      antiguedad_trabajo_anterior_anos: '', antiguedad_trabajo_anterior_meses: '',
      nombre_empresa_anterior: '', fecha_ingreso_trabajo_anterior: '',
      fecha_salida_trabajo_anterior: '', nombre_jefe_anterior: '', telefono_trabajo_anterior: '',
      pais_residencia: ''
    },
    referencias: [
      { numero_referencia: 1, tipo: 'normal', nombres: '', apellido_paterno: '', apellido_materno: '', telefono_celular: '', telefono_casa: '', telefono_oficina: '', parentesco: '', anos_conocerlo: '', email: '', direccion_completa: '' },
      { numero_referencia: 2, tipo: 'normal', nombres: '', apellido_paterno: '', apellido_materno: '', telefono_celular: '', telefono_casa: '', telefono_oficina: '', parentesco: '', anos_conocerlo: '', email: '', direccion_completa: '' }
    ],
    afirme: {
      cliente_afirme: false,
      es_accionista_credito_afirme: false,
      nombre_empresa_accionista: '',
      estado_civil_id: '',
      grado_estudios_id: '',
      tipo_institucion_estudios: '',
      situacion_vivienda_id: '',
      titular_anos_ramo: '',
      titular_ocupacion_actual_id: '',
      titular_giro_independiente_id: '',
      titular_sector_laboral_id: '',
      titular_actividad_especifica: '',
      titular_nombre_jefe_inmediato: '',
      titular_nombre_jefe_anterior: '',
      titular_ingreso_mensual_bruto: '',
      titular_gasto_mensual: '',
      titular_pago_mensual_renta: '',
      titular_ingreso_neto: '',
      coac_anos_ramo: '',
      coac_ocupacion_actual_id: '',
      coac_giro_independiente_id: '',
      coac_sector_laboral_id: '',
      coac_actividad_especifica: '',
      coac_nombre_jefe_inmediato: '',
      coac_nombre_jefe_anterior: '',
      coac_ingreso_mensual_bruto: '',
      coac_gasto_mensual: '',
      coac_pago_mensual_renta: '',
      coac_ingreso_neto: '',
      titular_padecimiento_corazon: false,
      titular_padecimiento_diabetes: false,
      titular_tratamiento_medico: false,
      titular_seguro_enfermedad_1: '',
      titular_seguro_duracion_1: '',
      titular_seguro_fecha_1: '',
      titular_seguro_condicion_1: '',
      titular_seguro_enfermedad_2: '',
      titular_seguro_duracion_2: '',
      titular_seguro_fecha_2: '',
      titular_seguro_condicion_2: '',
      coac_elegible: '',
      coac_padecimiento_corazon: false,
      coac_padecimiento_diabetes: false,
      coac_tratamiento_medico: false,
      coac_seguro_enfermedad_1: '',
      coac_seguro_duracion_1: '',
      coac_seguro_fecha_1: '',
      coac_seguro_condicion_1: '',
      coac_seguro_enfermedad_2: '',
      coac_seguro_duracion_2: '',
      coac_seguro_fecha_2: '',
      coac_seguro_condicion_2: '',
      oferta_vinculante: false,
      destino_credito_id: '',
      importe_credito_solicitado: '',
      valor_vivienda: '',
      tasa: '',
      plazo_anos_id: '',
      principal_forma_enganche_id: '',
      tipo_inmueble_id: '',
      vivienda_principal: false,
      municipio_vivienda: '',
      terreno_tiene_hipoteca: false,
      terreno_monto_deudor: ''
    },
    banorte: {
      cliente_banorte: false,
      estado_civil_id: '', regimen_conyugal_id: '', nivel_academico_profesion: '', tipo_domicilio_id: '',
      titular_actividad_empresarial: false, titular_tipo_contrato_id: '', titular_posicion_id: '',
      titular_puesto: '', titular_giro_actividad: '',
      titular_ingreso_mensual_bruto: '', titular_ingreso_mensual_neto: '', titular_otros_ingresos: '', titular_total_ingresos: '',
      titular_fuente_otros_ingresos: '',
      coac_actividad_empresarial: false, coac_tipo_contrato_id: '', coac_posicion_id: '',
      coac_puesto: '', coac_giro_actividad: '',
      coac_ingreso_mensual_bruto: '', coac_ingreso_mensual_neto: '', coac_otros_ingresos: '', coac_total_ingresos: '',
      coac_fuente_otros_ingresos: '',
      titular_med_corazon: false, titular_med_diabetes: false, titular_med_cancer: false, titular_med_rinones: false,
      titular_med_vih: false, titular_med_sistema_nervioso: false, titular_med_respiratorio: false, titular_med_tratamiento: false,
      coac_med_corazon: false, coac_med_diabetes: false, coac_med_cancer: false, coac_med_rinones: false,
      coac_med_vih: false, coac_med_sistema_nervioso: false, coac_med_respiratorio: false, coac_med_tratamiento: false,
      desempleo_tipo: '', obra_tipo: '', desempleo_suma_asegurada_meses: '', obra_valor: '',
      titular_des_contrato: false, titular_des_antiguedad: false, titular_des_no_aviso: false,
      coac_des_contrato: false, coac_des_antiguedad: false, coac_des_no_aviso: false,
      oferta_vinculante: false, esquema_id: '', tipo_credito_id: '', destino_credito_id: '', plazo_anos_id: '',
      tasa: '', importe: '', valor_inmueble: '', entidad_federativa_inmueble: '', comision_contratacion_financiada: false
    }
  });

function DropdownCheckbox({ label, opciones, seleccion, onToggle, onClear, todosLabel = 'Todos', ancho = 220, st }) {
  const [open, setOpen] = useState(false);
  const resumen = seleccion.length === 0
    ? todosLabel
    : seleccion.length === 1
      ? (opciones.find(o => o.v === seleccion[0])?.l ?? String(seleccion[0]))
      : `${seleccion.length} seleccionados`;
  return (
    <div style={{ width: ancho }}>
      <label style={st.label}>{label}</label>
      <div style={st.dropdownBox}>
        <button type="button" style={st.dropdownBtn} onClick={() => setOpen(o => !o)}>
          <span>{resumen}</span>
          <span style={{ color: '#6b7280' }}>▾</span>
        </button>
        {open && (
          <>
            <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 15 }} />
            <div style={st.dropdownMenu}>
              <label style={st.dropdownItem}>
                <input type="checkbox" checked={seleccion.length === 0} onChange={onClear} />
                <strong>{todosLabel}</strong>
              </label>
              <div style={st.dropdownDivider} />
              {opciones.map(o => (
                <label key={o.v} style={st.dropdownItem}>
                  <input type="checkbox" checked={seleccion.includes(o.v)} onChange={() => onToggle(o.v)} />
                  {o.l}
                </label>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default function Prospectos({ usuarioActual }) {
  const [view, setView] = useState('lista');
  const [prospectos, setProspectos] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [tiposIdentificacionSantander, setTiposIdentificacionSantander] = useState([]);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [municipiosCoacreditado, setMunicipiosCoacreditado] = useState([]);
  const [prospectoActual, setProspectoActual] = useState(null);
  const [filtroNombre, setFiltroNombre] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [filtroBrokers, setFiltroBrokers] = useState([]);
  const [filtroUsuarios, setFiltroUsuarios] = useState([]);
  const [seccionActiva, setSeccionActiva] = useState('titular');
  const [misLimites, setMisLimites] = useState(null);
  const validandoImssRef = useRef(false);
  const { isMobile, isTablet } = useResponsive();
  const esAdmin = usuarioActual?.rol === 'administrador';
  const esAdminPlus = usuarioActual?.rol === 'administrador_plus';
  // Básico (rol semiusuario): igual que Infonavit, el botón de captura sale deshabilitado
  // desde que carga la pantalla si no tiene capturas (límite 0) o ya llegó al límite.
  const esBasico = usuarioActual?.rol === 'semiusuario';
  const sinCapturas = esBasico && (!misLimites || (misLimites.limite_folios_banco_mes != null
    && misLimites.folios_banco_mes >= misLimites.limite_folios_banco_mes));
  const textoSinCapturas = misLimites && misLimites.limite_folios_banco_mes > 0
    ? 'Llegaste al límite de tus capturas del periodo. Contrata capturas extra para continuar.'
    : 'Tu plan no incluye capturas. Contrata capturas extra para continuar.';
  const verColumnaUsuario = esAdmin || esAdminPlus;
  const filtroUsuariosKey = useFiltroUsuarios().join(',');

  // Mide el alto del bloque título+buscador de la vista lista y lo publica,
  // para que el encabezado azul de la tabla se pegue justo debajo de él
  // (mismo patrón que --app-header-h en App.js).
  const listaCabeceraRef = useRef(null);
  const [listaCabeceraH, setListaCabeceraH] = useState(96);
  useEffect(() => {
    const el = listaCabeceraRef.current;
    if (!el) return;
    const medir = () => setListaCabeceraH(el.offsetHeight);
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    window.addEventListener('resize', medir);
    return () => { ro.disconnect(); window.removeEventListener('resize', medir); };
  }, [isMobile, view]);

  const [formData, setFormData] = useState(getInitialFormData());
  const [colonias, setColonias] = useState([]);
  const [coloniasTrabajo, setColoniasTrabajo] = useState([]);
  const [coloniasCoacreditado, setColoniasCoacreditado] = useState([]);
  const [coloniasTrabajoCoacreditado, setColoniasTrabajoCoacreditado] = useState([]);
  const [coloniaEditable, setColoniaEditable] = useState({ titular: false, coacreditado: false, trabajoTitular: false, trabajoCoacreditado: false });

  useEffect(() => {
    if (esAdmin) { loadBrokers(); loadUsuarios(); }
    loadGeneros();
    loadTiposIdentificacionSantander();
    loadEstados();
    if (!esAdmin) loadMisLimites();
  }, []);

  // Se recarga también al cambiar el filtro de usuarios del Administrador Plus.
  useEffect(() => {
    loadProspectos();
  }, [filtroUsuariosKey]);

  const loadProspectos = async () => {
    const r = await fetch(`${API}/prospectos`);
    const d = await r.json();
    setProspectos(d);
  };

  const loadMisLimites = async () => {
    const r = await fetch(`${API}/mi-perfil/limites`);
    const d = await r.json();
    setMisLimites(d);
  };

  const loadBrokers = async () => {
    const r = await fetch(`${API}/brokers`);
    const d = await r.json();
    setBrokers(d);
  };

  const loadUsuarios = async () => {
    const r = await fetch(`${API}/usuarios`);
    const d = await r.json();
    setUsuarios(d);
  };

  const loadGeneros = async () => {
    const r = await fetch(`${API}/catalogos/cat_genero`);
    const d = await r.json();
    setGeneros(d);
  };

  const loadTiposIdentificacionSantander = async () => {
    const r = await fetch(`${API}/catalogos/santander/tipo_identificacion`);
    const d = await r.json();
    setTiposIdentificacionSantander(d);
  };

  const loadEstados = async () => {
    const r = await fetch(`${API}/sepomex/estados`);
    const d = await r.json();
    setEstados(d);
  };

  const loadMunicipios = async (estado, esCoacreditado = false) => {
    if (!estado) {
      if (esCoacreditado) {
        setMunicipiosCoacreditado([]);
      } else {
        setMunicipios([]);
      }
      return;
    }
    const r = await fetch(`${API}/sepomex/municipios/${encodeURIComponent(estado)}`);
    const d = await r.json();
    if (esCoacreditado) {
      setMunicipiosCoacreditado(d);
    } else {
      setMunicipios(d);
    }
  };

  const loadProspecto = async (id) => {
    try {
      const r = await fetch(`${API}/prospectos/${id}`);
      const d = await r.json();
      
      if (d.prospecto) {
        setProspectoActual(d.prospecto);
        
        const newFormData = {
          fecha_solicitud: d.prospecto.fecha_solicitud.split('T')[0],
          broker_id: d.prospecto.broker_id,
          titular: formData.titular,
          coacreditado: formData.coacreditado,
          referencias: d.referencias && d.referencias.length > 0 ? d.referencias : formData.referencias,
          afirme: formData.afirme,
          banorte: formData.banorte
        };
        
        if (d.titular) {
          newFormData.titular = {
            ...d.titular,
            fecha_nacimiento: d.titular.fecha_nacimiento ? d.titular.fecha_nacimiento.split('T')[0] : '',
            fecha_ingreso_trabajo: d.titular.fecha_ingreso_trabajo ? d.titular.fecha_ingreso_trabajo.split('T')[0] : '',
            fecha_ingreso_trabajo_anterior: d.titular.fecha_ingreso_trabajo_anterior ? d.titular.fecha_ingreso_trabajo_anterior.split('T')[0] : '',
            fecha_salida_trabajo_anterior: d.titular.fecha_salida_trabajo_anterior ? d.titular.fecha_salida_trabajo_anterior.split('T')[0] : '',
            fecha_vigencia_identificacion: d.titular.fecha_vigencia_identificacion ? d.titular.fecha_vigencia_identificacion.split('T')[0] : ''
          };
          
          if (d.titular.codigo_postal) buscarColonias(d.titular.codigo_postal, false, false);
          if (d.titular.trabajo_codigo_postal) buscarColonias(d.titular.trabajo_codigo_postal, true, false);
          if (d.titular.entidad_nacimiento) loadMunicipios(d.titular.entidad_nacimiento, false);
        }
        
        if (d.coacreditado) {
          newFormData.coacreditado = {
            ...d.coacreditado,
            fecha_nacimiento: d.coacreditado.fecha_nacimiento ? d.coacreditado.fecha_nacimiento.split('T')[0] : '',
            fecha_ingreso_trabajo: d.coacreditado.fecha_ingreso_trabajo ? d.coacreditado.fecha_ingreso_trabajo.split('T')[0] : '',
            fecha_ingreso_trabajo_anterior: d.coacreditado.fecha_ingreso_trabajo_anterior ? d.coacreditado.fecha_ingreso_trabajo_anterior.split('T')[0] : '',
            fecha_salida_trabajo_anterior: d.coacreditado.fecha_salida_trabajo_anterior ? d.coacreditado.fecha_salida_trabajo_anterior.split('T')[0] : '',
            fecha_vigencia_identificacion: d.coacreditado.fecha_vigencia_identificacion ? d.coacreditado.fecha_vigencia_identificacion.split('T')[0] : ''
          };
          
          if (d.coacreditado.codigo_postal) buscarColonias(d.coacreditado.codigo_postal, false, true);
          if (d.coacreditado.trabajo_codigo_postal) buscarColonias(d.coacreditado.trabajo_codigo_postal, true, true);
          if (d.coacreditado.entidad_nacimiento) loadMunicipios(d.coacreditado.entidad_nacimiento, true);
        }
        
        setFormData(newFormData);
        setView('editar');
      }
    } catch (error) {
      console.error('Error cargando prospecto:', error);
      alert('Error al cargar prospecto');
    }
  };

  const buscarColonias = async (cp, esTrabajo = false, esCoacreditado = false) => {
    if (cp.length !== 5) {
      if (esCoacreditado) {
        if (esTrabajo) {
          setColoniasTrabajoCoacreditado([]);
        } else {
          setColoniasCoacreditado([]);
        }
      } else {
        if (esTrabajo) {
          setColoniasTrabajo([]);
        } else {
          setColonias([]);
        }
      }
      return;
    }
    
    try {
      const r = await fetch(`${API}/sepomex/cp/${cp}`);
      const d = await r.json();
      
      if (d && d.length > 0) {
        const seccion = esCoacreditado ? 'coacreditado' : 'titular';
        const campoCiudad = esTrabajo ? 'trabajo_ciudad' : 'ciudad';
        const campoEstado = esTrabajo ? 'trabajo_entidad_federativa' : 'entidad_federativa';
        
        if (esCoacreditado) {
          if (esTrabajo) {
            setColoniasTrabajoCoacreditado(d);
          } else {
            setColoniasCoacreditado(d);
          }
        } else {
          if (esTrabajo) {
            setColoniasTrabajo(d);
          } else {
            setColonias(d);
          }
        }
        
        updateField(seccion, campoCiudad, d[0].municipio || d[0].ciudad || '');
        updateField(seccion, campoEstado, d[0].estado);
      } else {
        alert('Código postal no encontrado en SEPOMEX');
      }
    } catch (error) {
      console.error('Error buscando código postal:', error);
      alert('Error al validar código postal');
    }
  };

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return { anos: '', meses: '' };
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let anos = hoy.getFullYear() - nacimiento.getFullYear();
    let meses = hoy.getMonth() - nacimiento.getMonth();
    if (hoy.getDate() < nacimiento.getDate()) {
      meses--;
    }
    if (meses < 0) {
      anos--;
      meses += 12;
    }
    return { anos, meses };
  };

  const calcularAntiguedad = (fechaIngreso) => {
    if (!fechaIngreso) return { anos: '', meses: '' };
    const hoy = new Date();
    const ingreso = new Date(fechaIngreso);
    let anos = hoy.getFullYear() - ingreso.getFullYear();
    let meses = hoy.getMonth() - ingreso.getMonth();
    if (hoy.getDate() < ingreso.getDate()) {
      meses--;
    }
    if (meses < 0) {
      anos--;
      meses += 12;
    }
    return { anos, meses };
  };

  const calcularAntiguedadEntreFechas = (fechaIngreso, fechaSalida) => {
    if (!fechaIngreso || !fechaSalida) return { anos: '', meses: '' };
    const ingreso = new Date(fechaIngreso);
    const salida = new Date(fechaSalida);

    if (salida < ingreso) return { anos: '', meses: '' }; // Fecha salida no puede ser antes del ingreso

    let anos = salida.getFullYear() - ingreso.getFullYear();
    let meses = salida.getMonth() - ingreso.getMonth();
    if (salida.getDate() < ingreso.getDate()) {
      meses--;
    }

    if (meses < 0) {
      anos--;
      meses += 12;
    }

    return { anos, meses };
  };

  const updateField = (seccion, campo, valor) => {
    if (seccion === 'referencias') {
      return; // Las referencias se manejan aparte
    }
    
    setFormData(prev => ({
      ...prev,
      [seccion]: {
        ...prev[seccion],
        [campo]: valor
      }
    }));

    const esCoacreditado = seccion === 'coacreditado';

    // Si corrigen el País de Nacimiento de vuelta a México, se limpia el
    // Lugar de Nacimiento capturado por error como extranjero (el campo se
    // oculta, pero sin esto el dato viejo se quedaba guardado sin verse).
    if (campo === 'pais_nacimiento' && esMexico(valor)) {
      setFormData(prev => ({
        ...prev,
        [seccion]: {
          ...prev[seccion],
          lugar_nacimiento_extranjero: ''
        }
      }));
    }

    if (campo === 'fecha_nacimiento') {
      const edad = calcularEdad(valor);
      setFormData(prev => ({
        ...prev,
        [seccion]: {
          ...prev[seccion],
          edad_anos: edad.anos,
          edad_meses: edad.meses
        }
      }));
    }

    if (campo === 'fecha_ingreso_trabajo') {
      const ant = calcularAntiguedad(valor);
      setFormData(prev => ({
        ...prev,
        [seccion]: {
          ...prev[seccion],
          antiguedad_trabajo_anos: ant.anos,
          antiguedad_trabajo_meses: ant.meses
        }
      }));
    }

// Calcular antigüedad trabajo anterior cuando cambian las fechas
    if (campo === 'fecha_ingreso_trabajo_anterior' || campo === 'fecha_salida_trabajo_anterior') {
      const fechaIngreso = campo === 'fecha_ingreso_trabajo_anterior' ? valor : formData[seccion].fecha_ingreso_trabajo_anterior;
      const fechaSalida = campo === 'fecha_salida_trabajo_anterior' ? valor : formData[seccion].fecha_salida_trabajo_anterior;
      
      if (fechaIngreso && fechaSalida) {
        const ant = calcularAntiguedadEntreFechas(fechaIngreso, fechaSalida);
        setFormData(prev => ({
          ...prev,
          [seccion]: {
            ...prev[seccion],
            antiguedad_trabajo_anterior_anos: ant.anos,
            antiguedad_trabajo_anterior_meses: ant.meses
          }
        }));
      }
    }


    if (campo === 'estatura_cms') {
      const mts = valor ? (parseFloat(valor) / 100).toFixed(2) : '';
      setFormData(prev => ({
        ...prev,
        [seccion]: {
          ...prev[seccion],
          estatura_mts: mts
        }
      }));
    }

    if (campo === 'codigo_postal') {
      buscarColonias(valor, false, esCoacreditado);
    }

    if (campo === 'trabajo_codigo_postal') {
      buscarColonias(valor, true, esCoacreditado);
    }

    if (campo === 'entidad_nacimiento') {
      loadMunicipios(valor, esCoacreditado);
      setFormData(prev => ({
        ...prev,
        [seccion]: {
          ...prev[seccion],
          municipio_nacimiento: ''
        }
      }));
    }
  };

  const CAMPOS_DOMICILIO_COACREDITADO = [
    'calle', 'no_ext', 'no_int', 'codigo_postal', 'colonia', 'ciudad',
    'entidad_federativa', 'pais', 'telefono_casa',
    'antiguedad_domicilio_anos', 'antiguedad_domicilio_meses', 'vive_en_casa',
  ];

  // Mientras el Coacreditado tenga marcado "mismo domicilio que el Titular", el
  // domicilio se mantiene sincronizado en automático: antes solo se copiaba una
  // vez al activar el checkbox, así que si luego se corregía el domicilio del
  // Titular, el Coacreditado se quedaba con el dato viejo hasta desactivar y
  // reactivar el checkbox manualmente.
  useEffect(() => {
    if (!formData.coacreditado.mismo_domicilio_titular) return;
    setFormData(prev => {
      if (!prev.coacreditado.mismo_domicilio_titular) return prev;
      let changed = false;
      const nuevoCoac = { ...prev.coacreditado };
      CAMPOS_DOMICILIO_COACREDITADO.forEach(c => {
        if (nuevoCoac[c] !== prev.titular[c]) { nuevoCoac[c] = prev.titular[c]; changed = true; }
      });
      return changed ? { ...prev, coacreditado: nuevoCoac } : prev;
    });
    if (formData.titular.codigo_postal) {
      buscarColonias(formData.titular.codigo_postal, false, true);
    }
    // La colonia del Coacreditado también sigue el modo (lista / texto libre)
    // del Titular: si el Titular la capturó con "✏️ Editar", el <select> del
    // Coacreditado no tiene esa opción y la mostraba vacía aunque sí se copió.
    setColoniaEditable(prev => (prev.coacreditado === prev.titular ? prev : { ...prev, coacreditado: prev.titular }));
  }, [
    formData.coacreditado.mismo_domicilio_titular,
    coloniaEditable.titular,
    ...CAMPOS_DOMICILIO_COACREDITADO.map(c => formData.titular[c]),
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  // El Número IMSS es opcional, pero si se captura algo debe quedar completo
  // (11 dígitos). Si queda a medias, se bloquea el cambio de campo hasta corregir.
  // El guard evita que el alert se dispare dos veces: el click que originó el
  // blur a veces se completa después de cerrar el alert() y vuelve a disparar blur.
  const validarNumeroImss = e => {
    const valor = e.target.value;
    if (valor.length > 0 && valor.length < 11) {
      if (validandoImssRef.current) return;
      validandoImssRef.current = true;
      alert('El Número IMSS debe tener 11 dígitos. Corrija el dato para continuar.');
      e.target.focus();
      setTimeout(() => { validandoImssRef.current = false; }, 0);
    }
  };

  // Calcula RFC y/o CURP a partir de nombre, apellidos, fecha de nacimiento,
  // sexo y entidad de nacimiento. Resultado editable, no se guarda solo.
  const calcularRfcCurp = (seccion, campo) => {
    const persona = formData[seccion];
    if (!persona.nombres || !persona.apellido_paterno || !persona.fecha_nacimiento) {
      alert('Para calcular, primero captura nombre(s), apellido paterno y fecha de nacimiento.');
      return;
    }
    if (campo === 'rfc') {
      const rfc = calcularRFC(persona);
      updateField(seccion, 'rfc', rfc);
    } else {
      // Nacido fuera de México: el CURP lleva la clave "NE" (Nacido en el
      // Extranjero) sin importar la entidad, así que solo se exige la entidad
      // de nacimiento cuando el país de nacimiento es México.
      const nacioEnMexico = !persona.pais_nacimiento || esMexico(persona.pais_nacimiento);
      if (!persona.sexo_genero_id || (nacioEnMexico && !persona.entidad_nacimiento)) {
        alert(nacioEnMexico
          ? 'Para calcular el CURP, también captura género y entidad de nacimiento.'
          : 'Para calcular el CURP, también captura el género.');
        return;
      }
      const curp = calcularCURP(persona);
      updateField(seccion, 'curp', curp);
    }
  };

  const updateReferencia = (index, campo, valor) => {
    setFormData(prev => ({
      ...prev,
      referencias: prev.referencias.map((ref, i) => 
        i === index ? { ...ref, [campo]: valor } : ref
      )
    }));
  };

  const agregarReferencia = () => {
    if (formData.referencias.length >= 4) {
      alert('Máximo 4 referencias');
      return;
    }
    const newNum = formData.referencias.length + 1;
    setFormData(prev => ({
      ...prev,
      referencias: [...prev.referencias, {
        numero_referencia: newNum,
        tipo: newNum === 4 ? 'extra' : 'normal',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        telefono_celular: '',
        telefono_casa: '',
        telefono_oficina: '',
        parentesco: '',
        anos_conocerlo: '',
        email: '',
        direccion_completa: ''
      }]
    }));
  };

  const eliminarReferencia = (index) => {
    if (formData.referencias.length <= 2) {
      alert('Debe haber al menos 2 referencias');
      return;
    }
    setFormData(prev => ({
      ...prev,
      referencias: prev.referencias.filter((_, i) => i !== index)
    }));
  };
  const guardarProspecto = async () => {
    if (!formData.titular.nombres || !formData.broker_id) {
      alert('Complete los campos requeridos: Nombre y Broker');
      return;
    }

    try {
      const url = view === 'editar' ? `${API}/prospectos/${prospectoActual.id}` : `${API}/prospectos`;
      const method = view === 'editar' ? 'PUT' : 'POST';
      
      const r = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const d = await r.json();
      if (d.success) {
        alert(view === 'editar' ? '✓ Prospecto actualizado correctamente' : `✓ Prospecto creado con Folio: ${d.prospecto.folio}`);
        setView('lista');
        loadProspectos();
      } else {
        alert('Error: ' + (d.error || 'Error desconocido'));
      }
    } catch (error) {
      console.error('Error guardando:', error);
      alert('Error al guardar prospecto');
    }
  };

  const guardarTitular = async () => {
    if (!formData.titular.nombres || !formData.broker_id) {
      alert('Complete los campos requeridos: Nombre y Broker');
      return;
    }
    if (view === 'nuevo') {
      const confirmado = window.confirm(
        '¿Seguro de guardarlo? ¿Ya revisaste el nombre completo del Titular (ya que no se podrá modificar posteriormente)?'
      );
      if (!confirmado) return;
    }
    let datosParaCrear = formData;
    let datosCopiados = null;
    if (view === 'nuevo') {
      try {
        const params = new URLSearchParams({
          nombres: formData.titular.nombres || '',
          apellido_paterno: formData.titular.apellido_paterno || '',
          apellido_materno: formData.titular.apellido_materno || ''
        });
        const rBuscar = await fetch(`${API}/prospectos/buscar-titular-previo?${params.toString()}`);
        const dBuscar = await rBuscar.json();
        if (dBuscar.encontrado) {
          const copiar = window.confirm(
            `Ya existe un folio previo (${dBuscar.folio}) capturado por usted con el mismo nombre de Titular. ¿Desea copiar la información de los módulos Titular, Coacreditado y Referencias de ese folio a este nuevo prospecto?`
          );
          if (copiar) {
            const rPrev = await fetch(`${API}/prospectos/${dBuscar.prospecto_id}`);
            const dPrev = await rPrev.json();
            const limpiarFechas = (obj, campos) => {
              const copia = { ...obj };
              delete copia.id; delete copia.prospecto_id; delete copia.created_at; delete copia.updated_at;
              campos.forEach(c => { copia[c] = obj[c] ? String(obj[c]).split('T')[0] : ''; });
              return copia;
            };
            const camposFecha = ['fecha_nacimiento', 'fecha_ingreso_trabajo', 'fecha_ingreso_trabajo_anterior', 'fecha_salida_trabajo_anterior', 'fecha_vigencia_identificacion'];
            const titularCopiado = dPrev.titular ? {
              ...limpiarFechas(dPrev.titular, camposFecha),
              nombres: formData.titular.nombres,
              apellido_paterno: formData.titular.apellido_paterno,
              apellido_materno: formData.titular.apellido_materno
            } : formData.titular;
            const coacreditadoCopiado = dPrev.coacreditado ? limpiarFechas(dPrev.coacreditado, camposFecha) : null;
            const referenciasCopiadas = dPrev.referencias && dPrev.referencias.length > 0
              ? dPrev.referencias.map(r => { const c = { ...r }; delete c.id; delete c.prospecto_id; delete c.created_at; delete c.updated_at; return c; })
              : null;
            datosCopiados = { coacreditado: coacreditadoCopiado, referencias: referenciasCopiadas };
            datosParaCrear = {
              ...formData,
              titular: titularCopiado,
              coacreditado: coacreditadoCopiado || formData.coacreditado,
              referencias: referenciasCopiadas || formData.referencias
            };
            setFormData(datosParaCrear);
          }
        }
      } catch (error) {
        console.error('Error buscando titular previo:', error);
      }
    }
    try {
      if (view === 'nuevo') {
        const r = await fetch(`${API}/prospectos`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(datosParaCrear)
        });
        const d = await r.json();
        if (d.success) {
          alert(`✓ Prospecto creado con Folio: ${d.prospecto.folio}`);
          setProspectoActual(d.prospecto);
          setView('editar');
          loadProspectos();
          if (!esAdmin) loadMisLimites();

          if (datosCopiados?.coacreditado) {
            await fetch(`${API}/prospectos/${d.prospecto.id}/coacreditado`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(datosCopiados.coacreditado)
            });
          }
          if (datosCopiados?.referencias) {
            await fetch(`${API}/prospectos/${d.prospecto.id}/referencias`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ referencias: datosCopiados.referencias })
            });
          }
        } else {
          alert('Error: ' + (d.error || 'Error desconocido'));
        }
      } else {
        const r = await fetch(`${API}/prospectos/${prospectoActual.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        });
        const d = await r.json();
        if (d.success) {
          alert('✓ Datos del titular actualizados');
        } else {
          alert('Error: ' + (d.error || 'Error desconocido'));
        }
      }
    } catch (error) {
      alert('Error al guardar titular');
    }
  };

  const guardarCoacreditado = async () => {
    if (!prospectoActual?.id) {
      alert('Primero guarde los datos del titular');
      return;
    }
    try {
      const r = await fetch(`${API}/prospectos/${prospectoActual.id}/coacreditado`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData.coacreditado)
      });
      const d = await r.json();
      if (d.success) {
        alert('✓ Datos del coacreditado actualizados');
      } else {
        alert('Error: ' + (d.error || 'Error desconocido'));
      }
    } catch (error) {
      alert('Error al guardar coacreditado');
    }
  };

  const guardarReferencias = async () => {
    if (!prospectoActual?.id) {
      alert('Primero guarde los datos del titular');
      return;
    }
    try {
      const r = await fetch(`${API}/prospectos/${prospectoActual.id}/referencias`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ referencias: formData.referencias })
      });
      const d = await r.json();
      if (d.success) {
        alert('✓ Referencias actualizadas');
      } else {
        alert('Error: ' + (d.error || 'Error desconocido'));
      }
    } catch (error) {
      alert('Error al guardar referencias');
    }
  };

  const st = {
    container: { padding: isMobile ? 12 : 24, maxWidth: 1400, margin: '0 auto' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 },
    headerSticky: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 16, position: 'sticky', top: 'var(--app-header-h, 120px)', backgroundColor: '#fff', zIndex: 30, padding: '12px 4px', borderBottom: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.06)' },
    btn: { padding: '10px 20px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold', fontSize: 14 },
    btnPrimary: { backgroundColor: '#1a3a6e', color: 'white' },
    btnSecondary: { backgroundColor: '#22c55e', color: 'white' },
    btnCancel: { backgroundColor: '#d1d5db', color: '#374151' },
    btnDanger: { backgroundColor: '#dc2626', color: 'white' },
    btnCalc: { padding: '8px 10px', border: '1px solid #1a3a6e', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: '600', backgroundColor: 'white', color: '#1a3a6e', whiteSpace: 'nowrap' },
    inputConBoton: { display: 'flex', gap: 6 },
    card: { backgroundColor: '#F0F0F0', border: '1px solid #e5e7eb', borderRadius: 8, padding: 24, marginBottom: 20 },
    section: { marginBottom: 32 },
    sectionTitle: { fontSize: 18, fontWeight: 'bold', color: '#1a3a6e', marginBottom: 20, paddingBottom: 8, borderBottom: '2px solid #f97316' },
    tabs: { display: 'flex', gap: 8, marginBottom: 24, borderBottom: '2px solid #e5e7eb', paddingBottom: 12, overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
    tab: { padding: '10px 20px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: '600', fontSize: 14, whiteSpace: 'nowrap', transition: 'background-color 0.15s ease', flexShrink: 0 },
    tabActive: { backgroundColor: '#e3cd9c', color: '#1a3a6e' },
    tabInactive: { backgroundColor: '#f3ead9', color: '#14532d' },
    tabStatusActive: { backgroundColor: '#FFC107', color: '#1a3a6e' },
    tabStatusInactive: { backgroundColor: '#ffe9a8', color: '#7a5c00' },
    moduloFijo: {
      position: 'fixed', left: 24, top: '50%', transform: 'translateY(-50%)',
      padding: '16px 8px', borderRadius: 8, fontWeight: '700', fontSize: 13,
      boxShadow: '0 2px 8px rgba(0,0,0,0.25)', zIndex: 1000,
      writingMode: 'vertical-rl', textOrientation: 'mixed', letterSpacing: 0.5
    },
    grid2: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: 16, marginBottom: 16 },
    grid3: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: 16, marginBottom: 16 },
    grid4: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: 16, marginBottom: 16 },
    grid5: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(5, 1fr)', gap: 16, marginBottom: 16 },
    rowPegado: { display: 'flex', flexWrap: 'wrap', gap: isMobile ? 16 : 35, marginBottom: 16 },
    field: { display: 'flex', flexDirection: 'column' },
    label: { display: 'block', fontSize: 13, fontWeight: '600', color: '#374151', marginBottom: 6 },
    input: { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
    inputNumber: { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, boxSizing: 'border-box', MozAppearance: 'textfield' },
    checkbox: { width: 18, height: 18, cursor: 'pointer' },
    refCard: { backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20, marginBottom: 16 },
    estaturaPesoBox: { backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '12px 16px 14px' },
    notaExclusiva: { fontSize: 11, color: '#6b7280', marginTop: 8, textAlign: 'center' },
    refHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: 16 },
    th: { backgroundColor: '#1a3a6e', color: 'white', padding: 12, textAlign: 'left', fontSize: 13 },
    thSticky: { backgroundColor: '#1a3a6e', color: 'white', padding: 12, textAlign: 'left', fontSize: 13, position: 'sticky', top: `calc(var(--app-header-h, 120px) + ${listaCabeceraH}px)`, zIndex: 10 },
    listaCabeceraSticky: { position: 'sticky', top: 'var(--app-header-h, 120px)', backgroundColor: '#fff', zIndex: 20, paddingTop: 4, paddingBottom: 8 },
    td: { padding: 12, borderBottom: '1px solid #e5e7eb', fontSize: 13 },
    dropdownBox: { position: 'relative' },
    dropdownBtn: { padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, backgroundColor: 'white', cursor: 'pointer', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, width: '100%', boxSizing: 'border-box' },
    dropdownMenu: { position: 'absolute', top: '100%', left: 0, marginTop: 4, backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 20, maxHeight: 320, overflowY: 'auto', padding: 6, minWidth: 220 },
    dropdownItem: { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', fontSize: 13, cursor: 'pointer', borderRadius: 4, whiteSpace: 'nowrap' },
    dropdownDivider: { borderTop: '1px solid #e5e7eb', margin: '4px 0' },
    fieldsetSoloLectura: { border: 0, padding: 0, margin: 0, minWidth: 0 }
  };

  const toggleFiltro = (arr, setArr, v) => setArr(arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v]);

  const prospectosFiltrados = prospectos.filter(p =>
    (p.titular_nombre || '').toLowerCase().includes(filtroNombre.trim().toLowerCase()) &&
    (filtroBrokers.length === 0 || filtroBrokers.includes(p.broker_id)) &&
    (filtroUsuarios.length === 0 || filtroUsuarios.includes(p.usuario_id))
  );

  const seccionesInfo = {
    titular: { label: '👤 Titular', style: st.tabActive },
    coacreditado: { label: '👥 Coacreditado', style: st.tabActive },
    referencias: { label: '📞 Referencias', style: st.tabActive },
    banco_afirme: { label: '🏦 Afirme', style: st.tabActive },
    banco_banamex: { label: '🏦 Banamex', style: st.tabActive },
    banco_banorte: { label: '🏦 Banorte', style: st.tabActive },
    banco_banregio: { label: '🏦 Banregio', style: st.tabActive },
    banco_hsbc: { label: '🏦 HSBC', style: st.tabActive },
    banco_santander: { label: '🏦 Santander', style: st.tabActive },
    banco_scotiabank: { label: '🏦 Scotiabank', style: st.tabActive },
    status: { label: '📌 Status', style: st.tabStatusActive }
  };

  // RENDER - LISTA
  if (view === 'lista') {
    return (
      <div style={st.container}>
        <div ref={listaCabeceraRef} style={st.listaCabeceraSticky}>
        <div style={st.header}>
          <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>📋 Captura de Prospectos</h2>
          <button onClick={() => {
            if (!esAdmin && misLimites?.limite_folios_banco_mes != null && misLimites.folios_banco_mes >= misLimites.limite_folios_banco_mes) {
              alert(`Ya llegó a su límite permitido de ${misLimites.limite_folios_banco_mes} folios de Banco para este mes.`);
              return;
            }
            setProspectoActual(null);
            setFormData(getInitialFormData());
            setView('nuevo');
            setSeccionActiva('titular');
            if (!esAdmin) {
              setFormData(f => ({ ...f, broker_id: usuarioActual.broker_id || '' }));
            }
          }} disabled={sinCapturas} title={sinCapturas ? textoSinCapturas : undefined}
            style={{ ...st.btn, ...st.btnSecondary, ...(sinCapturas ? { opacity: 0.5, cursor: 'not-allowed' } : {}) }}>
            + Nuevo Prospecto
          </button>
        </div>
        {sinCapturas && misLimites && (
          <div style={{ padding: '12px 16px', backgroundColor: '#fef3c7', border: '1px solid #fcd34d', borderRadius: 8, color: '#92400e', fontSize: 14, marginBottom: 16 }}>
            🔒 {textoSinCapturas}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 14, gap: 16, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ width: 260 }}>
              <label style={st.label}>Buscar por nombre de cliente</label>
              <input
                type="text"
                value={filtroNombre}
                onChange={e => setFiltroNombre(e.target.value)}
                placeholder="Escribe el nombre del cliente..."
                style={st.input}
              />
            </div>
            {usuarioActual?.rol === 'administrador' && (
              <>
                <DropdownCheckbox
                  label="Broker"
                  opciones={brokers.map(b => ({ v: b.id, l: b.nombre }))}
                  seleccion={filtroBrokers}
                  onToggle={v => toggleFiltro(filtroBrokers, setFiltroBrokers, v)}
                  onClear={() => setFiltroBrokers([])}
                  ancho={330}
                  st={st}
                />
                <DropdownCheckbox
                  label="Usuario"
                  opciones={usuarios.map(u => ({ v: u.id, l: u.nombre_completo || u.usuario }))}
                  seleccion={filtroUsuarios}
                  onToggle={v => toggleFiltro(filtroUsuarios, setFiltroUsuarios, v)}
                  onClear={() => setFiltroUsuarios([])}
                  ancho={330}
                  st={st}
                />
              </>
            )}
            {esAdminPlus && <FiltroUsuarios ancho={300} />}
          </div>
          {!esAdmin && misLimites && (
            <div style={{ fontSize: 14, fontWeight: 'bold', color: '#1a3a6e' }}>
              Folios Creados en el mes: {misLimites.folios_banco_mes}{misLimites.limite_folios_banco_mes != null ? ` / ${misLimites.limite_folios_banco_mes}` : ''}
            </div>
          )}
        </div>
        </div>

        <div style={st.card}>
          <table style={st.table}>
            <thead>
              <tr>
                <th style={st.thSticky}>Folio</th>
                <th style={st.thSticky}>Fecha</th>
                {verColumnaUsuario && <th style={st.thSticky}>Usuario</th>}
                <th style={st.thSticky}>Broker</th>
                <th style={st.thSticky}>Cliente</th>
                <th style={st.thSticky}>Estatus</th>
                <th style={{ ...st.thSticky, textAlign: 'center' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {prospectosFiltrados.map((p, i) => (
                <tr key={p.id} style={{ backgroundColor: i % 2 ? 'white' : '#f9fafb' }}>
                  <td style={{ ...st.td, fontWeight: 'bold', color: '#1a3a6e' }}>{p.folio}</td>
                  <td style={st.td}>{p.fecha_creacion
                    // Fecha de creación del registro (no la Fecha de Solicitud editable); se arma a mano para no desfasarla por zona horaria
                    ? p.fecha_creacion.split('-').map(Number).reverse().join('/')
                    : new Date(p.fecha_solicitud).toLocaleDateString()}</td>
                  {verColumnaUsuario && <td style={st.td}>{p.usuario_nombre || '-'}</td>}
                  <td style={st.td}>{p.broker_nombre}</td>
                  <td style={st.td}>{p.titular_nombre || '-'}</td>
                  <td style={st.td}>
                    <span style={{ 
                      padding: '4px 10px', 
                      borderRadius: 12, 
                      fontSize: 12, 
                      backgroundColor: '#dbeafe', 
                      color: '#1e40af' 
                    }}>
                      {p.estatus}
                    </span>
                  </td>
                  <td style={{ ...st.td, textAlign: 'center' }}>
                    <button 
                      onClick={() => loadProspecto(p.id)}
                      style={{ color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13 }}
                    >
                      {esAdminPlus && p.usuario_id !== usuarioActual.id ? '👁 Consultar' : 'Ver/Editar'}
                    </button>
                  </td>
                </tr>
              ))}
              {prospectosFiltrados.length === 0 && (
                <tr>
                  <td colSpan={verColumnaUsuario ? 7 : 6} style={{ ...st.td, textAlign: 'center', padding: 32, color: '#9ca3af' }}>
                    {prospectos.length === 0 ? 'No hay prospectos registrados' : 'No se encontraron clientes con ese nombre'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // RENDER - FORMULARIO (NUEVO O EDITAR)
  if (view === 'nuevo' || view === 'editar') {
    // Administrador Plus consultando el prospecto de un usuario asignado: todo
    // el formulario queda deshabilitado (el backend también rechaza escrituras).
    const soloLectura = view === 'editar' && esAdminPlus && prospectoActual && prospectoActual.usuario_id !== usuarioActual.id;
    return (
      <div style={st.container}>
        {!isMobile && seccionesInfo[seccionActiva] && (
          <div style={{ ...st.moduloFijo, ...seccionesInfo[seccionActiva].style }}>
            {seccionesInfo[seccionActiva].label}
          </div>
        )}
        <div style={st.headerSticky}>
          <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>
            {view === 'nuevo' ? '📝 Nuevo Prospecto' : `${soloLectura ? '👁 Consultar' : '📝 Editar'} Prospecto - Folio: ${prospectoActual?.folio || ''} - ${aMayusMinus([formData.titular?.nombres, formData.titular?.apellido_paterno, formData.titular?.apellido_materno].filter(Boolean).join(' '))}`}
          </h2>
          <button onClick={() => setView('lista')} style={{ ...st.btn, ...st.btnCancel }}>
            ← Volver
          </button>
        </div>

        {soloLectura && (
          <div style={{ backgroundColor: '#fef3c7', border: '1px solid #fcd34d', color: '#92400e', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 14 }}>
            👁 <strong>Solo lectura</strong> — este prospecto pertenece a otro usuario; puede consultarlo pero no modificarlo ni imprimirlo.
          </div>
        )}

        {/* INFORMACIÓN INICIAL */}
        <fieldset disabled={!!soloLectura} style={st.fieldsetSoloLectura}>
        <div style={st.card}>
          <div style={st.grid3}>
            <div style={st.field}>
              <label style={st.label}>Fecha de Solicitud *</label>
              <input 
                type="date" 
                value={formData.fecha_solicitud}
                onChange={e => setFormData({ ...formData, fecha_solicitud: e.target.value })}
                style={st.input}
              />
            </div>
            <div style={st.field}>
              <label style={st.label}>Broker *</label>
              {usuarioActual?.rol === 'administrador' ? (
                <select
                  value={formData.broker_id}
                  onChange={e => setFormData({ ...formData, broker_id: e.target.value })}
                  style={st.input}
                >
                  <option value="">-- Seleccionar --</option>
                  {brokers.map(b => <option key={b.id} value={b.id}>{b.nombre}</option>)}
                </select>
              ) : (
                <input value={(soloLectura ? prospectos.find(x => x.id === prospectoActual.id)?.broker_nombre : usuarioActual?.broker_nombre) || ''} disabled style={st.input} />
              )}
            </div>
          </div>
        </div>

        </fieldset>

        {/* TABS DE NAVEGACIÓN */}
        <div style={st.tabs}>
          <button 
            onClick={() => setSeccionActiva('titular')} 
            style={{ ...st.tab, ...(seccionActiva === 'titular' ? st.tabActive : st.tabInactive) }}
          >
            👤 Titular
          </button>
          <button 
            onClick={() => setSeccionActiva('coacreditado')} 
            style={{ ...st.tab, ...(seccionActiva === 'coacreditado' ? st.tabActive : st.tabInactive) }}
          >
            👥 Coacreditado
          </button>
          <button 
            onClick={() => setSeccionActiva('referencias')} 
            style={{ ...st.tab, ...(seccionActiva === 'referencias' ? st.tabActive : st.tabInactive) }}
          >
            📞 Referencias
          </button>
          <button
            onClick={() => setSeccionActiva('banco_afirme')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_afirme' ? st.tabActive : st.tabInactive) }}
          >
            🏦 Afirme
          </button>
          <button
            onClick={() => setSeccionActiva('banco_banamex')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_banamex' ? st.tabActive : st.tabInactive) }}
          >
            🏦 Banamex
          </button>
          <button
            onClick={() => setSeccionActiva('banco_banorte')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_banorte' ? st.tabActive : st.tabInactive) }}
          >
            🏦 Banorte
          </button>
          <button
            onClick={() => setSeccionActiva('banco_banregio')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_banregio' ? st.tabActive : st.tabInactive) }}
          >
            🏦 Banregio
          </button>
          <button
            onClick={() => setSeccionActiva('banco_hsbc')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_hsbc' ? st.tabActive : st.tabInactive) }}
          >
            🏦 HSBC
          </button>
          <button
            onClick={() => setSeccionActiva('banco_santander')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_santander' ? st.tabActive : st.tabInactive) }}
          >
            🏦 Santander
          </button>
          <button
            onClick={() => setSeccionActiva('banco_scotiabank')}
            style={{ ...st.tab, ...(seccionActiva === 'banco_scotiabank' ? st.tabActive : st.tabInactive) }}
          >
            🏦 Scotiabank
          </button>
          <button
            onClick={() => setSeccionActiva('status')}
            style={{ ...st.tab, ...(seccionActiva === 'status' ? st.tabStatusActive : st.tabStatusInactive) }}
          >
            📌 Status
          </button>
        </div>
        {/* CONTENIDO DE LAS SECCIONES */}
        <fieldset disabled={!!soloLectura} style={st.fieldsetSoloLectura}>
        {seccionActiva === 'titular' && (
          <div>
            {/* INFORMACIÓN GENERAL DEL TITULAR */}
            <div style={st.card}>
              <h3 style={st.sectionTitle}>👤 Información General del Titular</h3>
              
              <div style={st.grid3}>
                <div style={st.field}>
                  <label style={st.label}>Nombre(s) *</label>
                  <input value={formData.titular.nombres} onChange={e => updateField('titular', 'nombres', e.target.value)} style={view === 'editar' ? { ...st.input, backgroundColor: '#f3f4f6' } : st.input} disabled={view === 'editar'} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Apellido Paterno *</label>
                  <input value={formData.titular.apellido_paterno} onChange={e => updateField('titular', 'apellido_paterno', e.target.value)} style={view === 'editar' ? { ...st.input, backgroundColor: '#f3f4f6' } : st.input} disabled={view === 'editar'} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Apellido Materno</label>
                  <input value={formData.titular.apellido_materno} onChange={e => updateField('titular', 'apellido_materno', e.target.value)} style={view === 'editar' ? { ...st.input, backgroundColor: '#f3f4f6' } : st.input} disabled={view === 'editar'} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Fecha de Nacimiento</label>
                  <input type="date" value={formData.titular.fecha_nacimiento} onChange={e => updateField('titular', 'fecha_nacimiento', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Edad (Años)</label>
                  <input type="text" value={formData.titular.edad_anos} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Edad (Meses)</label>
                  <input type="text" value={formData.titular.edad_meses} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Sexo/Género</label>
                  <select value={formData.titular.sexo_genero_id} onChange={e => updateField('titular', 'sexo_genero_id', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {generos.map(g => <option key={g.id} value={g.id}>{g.nombre}</option>)}
                  </select>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 234 }}>
                  <label style={st.label}>Estado Civil</label>
                  <select
                    value={formData.titular.estado_civil}
                    onChange={e => {
                      updateField('titular', 'estado_civil', e.target.value);
                      if (e.target.value !== 'Casado') updateField('titular', 'regimen_matrimonio', '');
                    }}
                    style={st.input}
                  >
                    <option value="">-- Seleccionar --</option>
                    {ESTADOS_CIVILES.map(ec => <option key={ec} value={ec}>{ec}</option>)}
                  </select>
                </div>
                {formData.titular.estado_civil === 'Casado' && (
                  <div style={{ ...st.field, width: isMobile ? '100%' : 234 }}>
                    <label style={st.label}>Régimen de Matrimonio</label>
                    <select value={formData.titular.regimen_matrimonio} onChange={e => updateField('titular', 'regimen_matrimonio', e.target.value)} style={st.input}>
                      <option value="">-- Seleccionar --</option>
                      {REGIMENES_MATRIMONIO.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                  </div>
                )}
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>País de Nacimiento</label>
                  <input value={formData.titular.pais_nacimiento} onChange={e => updateField('titular', 'pais_nacimiento', e.target.value)} style={st.input} />
                  <div style={{ marginTop: 8 }}>
                    <label style={st.label}>País de Residencia</label>
                    <input value={formData.titular.pais_residencia} onChange={e => updateField('titular', 'pais_residencia', e.target.value)} style={st.input} />
                    <p style={{ fontSize: 10, color: '#9ca3af', margin: '2px 0 0' }}>Exclusivo HSBC</p>
                  </div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>Nacionalidad</label>
                  <input value={formData.titular.nacionalidad} onChange={e => updateField('titular', 'nacionalidad', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 235 }}>
                  <label style={st.label}>Entidad Federativa Nacimiento</label>
                  <select value={formData.titular.entidad_nacimiento} onChange={e => updateField('titular', 'entidad_nacimiento', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {estados.map((est, i) => <option key={i} value={est.estado}>{est.estado}</option>)}
                  </select>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 306 }}>
                  <label style={st.label}>Municipio Nacimiento</label>
                  <select value={formData.titular.municipio_nacimiento} onChange={e => updateField('titular', 'municipio_nacimiento', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {municipios.map((mun, i) => <option key={i} value={mun.municipio}>{mun.municipio}</option>)}
                  </select>
                </div>
                {!esMexico(formData.titular.pais_nacimiento) && (
                  <div style={{ ...st.field, width: isMobile ? '100%' : 235 }}>
                    <label style={st.label}>Lugar de Nacimiento</label>
                    <input value={formData.titular.lugar_nacimiento_extranjero} onChange={e => updateField('titular', 'lugar_nacimiento_extranjero', e.target.value)} style={st.input} />
                    <p style={{ fontSize: 10, color: '#9ca3af', margin: '2px 0 0' }}>Exclusivo Extranjero</p>
                  </div>
                )}
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 275 }}>
                  <label style={st.label}>RFC</label>
                  <div style={st.inputConBoton}>
                    <input maxLength={13} value={formData.titular.rfc} onChange={e => updateField('titular', 'rfc', e.target.value.toUpperCase())} style={st.input} />
                    <button type="button" onClick={() => calcularRfcCurp('titular', 'rfc')} style={st.btnCalc}>Calcular</button>
                  </div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 275 }}>
                  <label style={st.label}>CURP</label>
                  <div style={st.inputConBoton}>
                    <input maxLength={18} value={formData.titular.curp} onChange={e => updateField('titular', 'curp', e.target.value.toUpperCase())} style={st.input} />
                    <button type="button" onClick={() => calcularRfcCurp('titular', 'curp')} style={st.btnCalc}>Calcular</button>
                  </div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
                  <label style={st.label}>Número IMSS</label>
                  <input maxLength={11} value={formData.titular.numero_imss} onChange={e => updateField('titular', 'numero_imss', e.target.value.replace(/\D/g, ''))} onBlur={validarNumeroImss} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={st.estaturaPesoBox}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 240 }}>
                      <label style={st.label}>No. de Identificación</label>
                      <input maxLength={13} value={formData.titular.numero_identificacion} onChange={e => updateField('titular', 'numero_identificacion', e.target.value)} style={st.input} />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 240 }}>
                      <label style={st.label}>Fecha Vigencia ID</label>
                      <input type="date" value={formData.titular.fecha_vigencia_identificacion} onChange={e => updateField('titular', 'fecha_vigencia_identificacion', e.target.value)} style={st.input} />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                      <label style={st.label}>Tipo Identificación</label>
                      <input value={formData.titular.tipo_identificacion} onChange={e => updateField('titular', 'tipo_identificacion', e.target.value)} style={st.input} placeholder="INE, Pasaporte..." />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 300 }}>
                      <label style={st.label}>Tipo Identificación <span style={{ fontWeight: 'normal', fontSize: 11, color: '#888' }}>(Exclusivo Santander)</span></label>
                      <select value={formData.titular.tipo_identificacion_santander_id} onChange={e => updateField('titular', 'tipo_identificacion_santander_id', e.target.value)} style={st.input}>
                        <option value="">-- Seleccionar --</option>
                        {tiposIdentificacionSantander.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={st.notaExclusiva}>Exclusivos para Banamex, HSBC, Santander y Scotiabank</div>
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={st.estaturaPesoBox}>
                  <div style={{ display: 'flex', gap: 35 }}>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                      <label style={st.label}>Estatura (cms)</label>
                      <input
                        type="number"
                        value={formData.titular.estatura_cms}
                        onChange={e => updateField('titular', 'estatura_cms', e.target.value)}
                        style={st.inputNumber}
                        placeholder="ej: 170"
                      />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                      <label style={st.label}>Estatura (mts)</label>
                      <input
                        type="text"
                        value={formData.titular.estatura_mts}
                        readOnly
                        style={{ ...st.input, backgroundColor: '#f3f4f6' }}
                        placeholder="automático"
                      />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                      <label style={st.label}>Peso (kg)</label>
                      <input
                        type="number"
                        value={formData.titular.peso_kg}
                        onChange={e => updateField('titular', 'peso_kg', e.target.value)}
                        style={st.inputNumber}
                        placeholder="ej: 75"
                      />
                    </div>
                  </div>
                  <div style={st.notaExclusiva}>Exclusivo Afirme, Banamex, HSBC y Santander</div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                  <label style={st.label}>Núm. Dependientes</label>
                  <input
                    type="number"
                    value={formData.titular.num_dependientes}
                    onChange={e => updateField('titular', 'num_dependientes', e.target.value)}
                    style={st.inputNumber}
                    placeholder="0"
                  />
                </div>
              </div>
            </div>

            {/* DIRECCIÓN TITULAR */}
            <div style={st.card}>
              <h3 style={st.sectionTitle}>🏠 Dirección del Titular</h3>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 480 }}>
                  <label style={st.label}>Calle</label>
                  <input value={formData.titular.calle} onChange={e => updateField('titular', 'calle', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Ext</label>
                  <input value={formData.titular.no_ext} onChange={e => updateField('titular', 'no_ext', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Int</label>
                  <input value={formData.titular.no_int} onChange={e => updateField('titular', 'no_int', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 110 }}>
                  <label style={st.label}>Código Postal</label>
                  <input
                    maxLength={5}
                    value={formData.titular.codigo_postal}
                    onChange={e => updateField('titular', 'codigo_postal', e.target.value.replace(/\D/g, ''))}
                    style={st.input}
                    placeholder="5 dígitos"
                  />
                </div>
              </div>

              <div style={st.grid3}>
                <div style={st.field}>
                  <label style={st.label}>Colonia</label>
                  <div style={st.inputConBoton}>
                    {coloniaEditable.titular ? (
                      <input value={formData.titular.colonia} onChange={e => updateField('titular', 'colonia', e.target.value)} style={st.input} />
                    ) : (
                      <select value={formData.titular.colonia} onChange={e => updateField('titular', 'colonia', e.target.value)} style={st.input}>
                        <option value="">-- Seleccionar --</option>
                        {colonias.map((c, i) => <option key={i} value={c.colonia}>{c.colonia}</option>)}
                      </select>
                    )}
                    <button type="button" onClick={() => setColoniaEditable(prev => ({ ...prev, titular: !prev.titular }))} style={st.btnCalc}>
                      {coloniaEditable.titular ? 'Lista' : '✏️ Editar'}
                    </button>
                  </div>
                </div>
                <div style={st.field}>
                  <label style={st.label}>Ciudad/Población</label>
                  <input value={formData.titular.ciudad} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Entidad Federativa</label>
                  <input value={formData.titular.entidad_federativa} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
              </div>


              <div style={st.grid4}>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Actual (Años)</label>
                  <input
                    type="number"
                    value={formData.titular.antiguedad_domicilio_anos}
                    onChange={e => updateField('titular', 'antiguedad_domicilio_anos', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Actual (Meses)</label>
                  <input
                    type="number"
                    value={formData.titular.antiguedad_domicilio_meses}
                    onChange={e => updateField('titular', 'antiguedad_domicilio_meses', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Anterior (Años)</label>
                  <input
                    type="number"
                    value={formData.titular.antiguedad_domicilio_anterior_anos}
                    onChange={e => updateField('titular', 'antiguedad_domicilio_anterior_anos', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Anterior (Meses)</label>
                  <input
                    type="number"
                    value={formData.titular.antiguedad_domicilio_anterior_meses}
                    onChange={e => updateField('titular', 'antiguedad_domicilio_anterior_meses', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                  />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
                  <label style={st.label}>Teléfono Casa</label>
                  <input maxLength={10} value={formData.titular.telefono_casa} onChange={e => updateField('titular', 'telefono_casa', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
                  <label style={st.label}>Teléfono Celular</label>
                  <input maxLength={10} value={formData.titular.telefono_celular} onChange={e => updateField('titular', 'telefono_celular', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 300 }}>
                  <label style={st.label}>Email</label>
                  <input type="email" value={formData.titular.email} onChange={e => updateField('titular', 'email', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 180 }}>
                  <label style={st.label}>Vive en Casa</label>
                  <select value={formData.titular.vive_en_casa} onChange={e => updateField('titular', 'vive_en_casa', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {VIVE_EN_CASA_OPCIONES.map(v => <option key={v} value={v}>{v}</option>)}
                  </select>
                </div>
              </div>

            </div>

            {/* TRABAJO TITULAR - Incluye trabajo anterior */}
            <div style={st.card}>
              <h3 style={st.sectionTitle}>💼 Datos del Trabajo del Titular</h3>
              
              <div style={{ ...st.grid2, marginBottom: 16 }}>
                <div style={st.field}>
                  <label style={st.label}>Nombre de la Empresa</label>
                  <input value={formData.titular.nombre_empresa} onChange={e => updateField('titular', 'nombre_empresa', e.target.value)} style={st.input} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>RFC de la Empresa <span style={{ fontWeight: 'normal', color: '#888' }}>(opcional)</span></label>
                  <input maxLength={13} value={formData.titular.rfc_empresa} onChange={e => updateField('titular', 'rfc_empresa', e.target.value.toUpperCase())} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 480 }}>
                  <label style={st.label}>Calle</label>
                  <input value={formData.titular.trabajo_calle} onChange={e => updateField('titular', 'trabajo_calle', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Ext</label>
                  <input value={formData.titular.trabajo_no_ext} onChange={e => updateField('titular', 'trabajo_no_ext', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Int</label>
                  <input value={formData.titular.trabajo_no_int} onChange={e => updateField('titular', 'trabajo_no_int', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 110 }}>
                  <label style={st.label}>Código Postal</label>
                  <input
                    maxLength={5}
                    value={formData.titular.trabajo_codigo_postal}
                    onChange={e => updateField('titular', 'trabajo_codigo_postal', e.target.value.replace(/\D/g, ''))}
                    style={st.input}
                    placeholder="5 dígitos"
                  />
                </div>
              </div>

              <div style={st.grid4}>
                <div style={st.field}>
                  <label style={st.label}>Colonia</label>
                  <div style={st.inputConBoton}>
                    {coloniaEditable.trabajoTitular ? (
                      <input value={formData.titular.trabajo_colonia} onChange={e => updateField('titular', 'trabajo_colonia', e.target.value)} style={st.input} />
                    ) : (
                      <select value={formData.titular.trabajo_colonia} onChange={e => updateField('titular', 'trabajo_colonia', e.target.value)} style={st.input}>
                        <option value="">-- Seleccionar --</option>
                        {coloniasTrabajo.map((c, i) => <option key={i} value={c.colonia}>{c.colonia}</option>)}
                        {formData.titular.trabajo_colonia && !coloniasTrabajo.some(c => c.colonia === formData.titular.trabajo_colonia) && (
                          <option value={formData.titular.trabajo_colonia}>{formData.titular.trabajo_colonia}</option>
                        )}
                      </select>
                    )}
                    <button type="button" onClick={() => setColoniaEditable(prev => ({ ...prev, trabajoTitular: !prev.trabajoTitular }))} style={st.btnCalc}>
                      {coloniaEditable.trabajoTitular ? 'Lista' : '✏️ Editar'}
                    </button>
                  </div>
                </div>
                <div style={st.field}>
                  <label style={st.label}>Ciudad/Municipio</label>
                  <input value={formData.titular.trabajo_ciudad} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Entidad Federativa</label>
                  <input value={formData.titular.trabajo_entidad_federativa} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>País</label>
                  <input value={formData.titular.trabajo_pais} onChange={e => updateField('titular', 'trabajo_pais', e.target.value)} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                  <label style={st.label}>Teléfono</label>
                  <input maxLength={10} value={formData.titular.trabajo_telefono} onChange={e => updateField('titular', 'trabajo_telefono', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 130 }}>
                  <label style={st.label}>Extensión</label>
                  <input value={formData.titular.trabajo_extension} onChange={e => updateField('titular', 'trabajo_extension', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>Fecha Ingreso</label>
                  <input type="date" value={formData.titular.fecha_ingreso_trabajo} onChange={e => updateField('titular', 'fecha_ingreso_trabajo', e.target.value)} style={st.input} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad (Años/Meses)</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input type="text" value={formData.titular.antiguedad_trabajo_anos} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6', width: isMobile ? '50%' : 160 }} placeholder="años" />
                    <input type="text" value={formData.titular.antiguedad_trabajo_meses} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6', width: isMobile ? '50%' : 160 }} placeholder="meses" />
                  </div>
                </div>
              </div>

              {!(parseInt(formData.titular.antiguedad_trabajo_anos, 10) >= 2) && (
              <div style={{ marginTop: 24, paddingTop: 20, borderTop: '2px solid #e5e7eb' }}>
                <h4 style={{ fontSize: 16, fontWeight: 'bold', color: '#6b7280', marginBottom: 4 }}>Trabajo Anterior</h4>
                <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 0, marginBottom: 16 }}>Se requiere para cuando se tenga menos de 2 años en trabajo actual y sea Empleado</p>

                <div style={{ marginBottom: 16 }}>
                  <div style={st.field}>
                    <label style={st.label}>Nombre Empresa Anterior</label>
                    <input value={formData.titular.nombre_empresa_anterior} onChange={e => updateField('titular', 'nombre_empresa_anterior', e.target.value)} style={st.input} />
                  </div>
                </div>
                <div style={st.grid4}>
                  <div style={st.field}>
                    <label style={st.label}>Fecha Ingreso Trabajo Anterior</label>
                    <input type="date" value={formData.titular.fecha_ingreso_trabajo_anterior} onChange={e => updateField('titular', 'fecha_ingreso_trabajo_anterior', e.target.value)} style={st.input} />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Fecha Salida Trabajo Anterior</label>
                    <input type="date" value={formData.titular.fecha_salida_trabajo_anterior} onChange={e => updateField('titular', 'fecha_salida_trabajo_anterior', e.target.value)} style={st.input} />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Nombre Jefe Anterior</label>
                    <input value={formData.titular.nombre_jefe_anterior} onChange={e => updateField('titular', 'nombre_jefe_anterior', e.target.value)} style={st.input} />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Teléfono Empresa Anterior</label>
                    <input value={formData.titular.telefono_trabajo_anterior} onChange={e => updateField('titular', 'telefono_trabajo_anterior', e.target.value)} style={st.input} maxLength={10} />
                  </div>
		<div style={st.field}>
                  <label style={st.label}>Antigüedad Anterior (Años)</label>
                  <input
                    type="text"
                    value={formData.titular.antiguedad_trabajo_anterior_anos}
                    readOnly
                    style={{ ...st.input, backgroundColor: '#f3f4f6', width: '70%' }}
                    placeholder="automático"
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Anterior (Meses)</label>
                  <input
                    type="text"
                    value={formData.titular.antiguedad_trabajo_anterior_meses}
                    readOnly
                    style={{ ...st.input, backgroundColor: '#f3f4f6', width: '70%' }}
                    placeholder="automático"
                  />
                </div>
                </div>
              </div>
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <button onClick={guardarTitular} style={{ ...st.btn, ...st.btnPrimary }}>
                💾 {view === 'nuevo' ? 'Crear Folio y Guardar Titular' : 'Actualizar Titular'}
              </button>
            </div>
          </div>
        )}

        {seccionActiva === 'coacreditado' && (
          <div>
            {/* PREGUNTAS INICIALES */}
            <div style={st.card}>
              <h3 style={st.sectionTitle}>👥 Coacreditado - Preguntas Iniciales</h3>
              <div style={st.grid3}>
                <div style={st.field}>
                  <label style={st.label}>¿Es cónyuge o pareja del Titular?</label>
                  <select 
                    value={formData.coacreditado.es_conyuge ? 'true' : 'false'} 
                    onChange={e => updateField('coacreditado', 'es_conyuge', e.target.value === 'true')} 
                    style={st.input}
                  >
                    <option value="false">No</option>
                    <option value="true">Sí</option>
                  </select>
                </div>
                <div style={st.field}>
                  <label style={st.label}>¿Participa con Ingresos?</label>
                  <select 
                    value={formData.coacreditado.participa_ingresos ? 'true' : 'false'} 
                    onChange={e => updateField('coacreditado', 'participa_ingresos', e.target.value === 'true')} 
                    style={st.input}
                  >
                    <option value="false">No</option>
                    <option value="true">Sí</option>
                  </select>
                </div>
                <div style={st.field}>
                  <label style={st.label}>¿Mismo Domicilio que el Titular?</label>
                  <select 
                    value={formData.coacreditado.mismo_domicilio_titular ? 'true' : 'false'} 
                    onChange={e => updateField('coacreditado', 'mismo_domicilio_titular', e.target.value === 'true')} 
                    style={st.input}
                  >
                    <option value="false">No</option>
                    <option value="true">Sí</option>
                  </select>
                </div>
              </div>
            </div>

            {/* INFORMACIÓN GENERAL COACREDITADO */}
            <div style={st.card}>
              <h3 style={st.sectionTitle}>👤 Información General del Coacreditado</h3>
              
              <div style={st.grid3}>
                <div style={st.field}>
                  <label style={st.label}>Nombre(s)</label>
                  <input value={formData.coacreditado.nombres} onChange={e => updateField('coacreditado', 'nombres', e.target.value)} style={st.input} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Apellido Paterno</label>
                  <input value={formData.coacreditado.apellido_paterno} onChange={e => updateField('coacreditado', 'apellido_paterno', e.target.value)} style={st.input} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Apellido Materno</label>
                  <input value={formData.coacreditado.apellido_materno} onChange={e => updateField('coacreditado', 'apellido_materno', e.target.value)} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Fecha de Nacimiento</label>
                  <input type="date" value={formData.coacreditado.fecha_nacimiento} onChange={e => updateField('coacreditado', 'fecha_nacimiento', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Edad (Años)</label>
                  <input type="text" value={formData.coacreditado.edad_anos} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Edad (Meses)</label>
                  <input type="text" value={formData.coacreditado.edad_meses} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 150 }}>
                  <label style={st.label}>Sexo/Género</label>
                  <select value={formData.coacreditado.sexo_genero_id} onChange={e => updateField('coacreditado', 'sexo_genero_id', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {generos.map(g => <option key={g.id} value={g.id}>{g.nombre}</option>)}
                  </select>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 234 }}>
                  <label style={st.label}>Estado Civil</label>
                  <select
                    value={formData.coacreditado.estado_civil}
                    onChange={e => {
                      updateField('coacreditado', 'estado_civil', e.target.value);
                      if (e.target.value !== 'Casado') updateField('coacreditado', 'regimen_matrimonio', '');
                    }}
                    style={st.input}
                  >
                    <option value="">-- Seleccionar --</option>
                    {ESTADOS_CIVILES.map(ec => <option key={ec} value={ec}>{ec}</option>)}
                  </select>
                </div>
                {formData.coacreditado.estado_civil === 'Casado' && (
                  <div style={{ ...st.field, width: isMobile ? '100%' : 234 }}>
                    <label style={st.label}>Régimen de Matrimonio</label>
                    <select value={formData.coacreditado.regimen_matrimonio} onChange={e => updateField('coacreditado', 'regimen_matrimonio', e.target.value)} style={st.input}>
                      <option value="">-- Seleccionar --</option>
                      {REGIMENES_MATRIMONIO.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                  </div>
                )}
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>País de Nacimiento</label>
                  <input value={formData.coacreditado.pais_nacimiento} onChange={e => updateField('coacreditado', 'pais_nacimiento', e.target.value)} style={st.input} />
                  <div style={{ marginTop: 8 }}>
                    <label style={st.label}>País de Residencia</label>
                    <input value={formData.coacreditado.pais_residencia} onChange={e => updateField('coacreditado', 'pais_residencia', e.target.value)} style={st.input} />
                    <p style={{ fontSize: 10, color: '#9ca3af', margin: '2px 0 0' }}>Exclusivo HSBC</p>
                  </div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>Nacionalidad</label>
                  <input value={formData.coacreditado.nacionalidad} onChange={e => updateField('coacreditado', 'nacionalidad', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 235 }}>
                  <label style={st.label}>Entidad Federativa Nacimiento</label>
                  <select value={formData.coacreditado.entidad_nacimiento} onChange={e => updateField('coacreditado', 'entidad_nacimiento', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {estados.map((est, i) => <option key={i} value={est.estado}>{est.estado}</option>)}
                  </select>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 306 }}>
                  <label style={st.label}>Municipio Nacimiento</label>
                  <select value={formData.coacreditado.municipio_nacimiento} onChange={e => updateField('coacreditado', 'municipio_nacimiento', e.target.value)} style={st.input}>
                    <option value="">-- Seleccionar --</option>
                    {municipiosCoacreditado.map((mun, i) => <option key={i} value={mun.municipio}>{mun.municipio}</option>)}
                  </select>
                </div>
                {!esMexico(formData.coacreditado.pais_nacimiento) && (
                  <div style={{ ...st.field, width: isMobile ? '100%' : 235 }}>
                    <label style={st.label}>Lugar de Nacimiento</label>
                    <input value={formData.coacreditado.lugar_nacimiento_extranjero} onChange={e => updateField('coacreditado', 'lugar_nacimiento_extranjero', e.target.value)} style={st.input} />
                    <p style={{ fontSize: 10, color: '#9ca3af', margin: '2px 0 0' }}>Exclusivo Extranjero</p>
                  </div>
                )}
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 275 }}>
                  <label style={st.label}>RFC</label>
                  <div style={st.inputConBoton}>
                    <input maxLength={13} value={formData.coacreditado.rfc} onChange={e => updateField('coacreditado', 'rfc', e.target.value.toUpperCase())} style={st.input} />
                    <button type="button" onClick={() => calcularRfcCurp('coacreditado', 'rfc')} style={st.btnCalc}>Calcular</button>
                  </div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 275 }}>
                  <label style={st.label}>CURP</label>
                  <div style={st.inputConBoton}>
                    <input maxLength={18} value={formData.coacreditado.curp} onChange={e => updateField('coacreditado', 'curp', e.target.value.toUpperCase())} style={st.input} />
                    <button type="button" onClick={() => calcularRfcCurp('coacreditado', 'curp')} style={st.btnCalc}>Calcular</button>
                  </div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
                  <label style={st.label}>Número IMSS</label>
                  <input maxLength={11} value={formData.coacreditado.numero_imss} onChange={e => updateField('coacreditado', 'numero_imss', e.target.value.replace(/\D/g, ''))} onBlur={validarNumeroImss} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={st.estaturaPesoBox}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 240 }}>
                      <label style={st.label}>No. de Identificación</label>
                      <input maxLength={13} value={formData.coacreditado.numero_identificacion} onChange={e => updateField('coacreditado', 'numero_identificacion', e.target.value)} style={st.input} />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 240 }}>
                      <label style={st.label}>Fecha Vigencia ID</label>
                      <input type="date" value={formData.coacreditado.fecha_vigencia_identificacion} onChange={e => updateField('coacreditado', 'fecha_vigencia_identificacion', e.target.value)} style={st.input} />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                      <label style={st.label}>Tipo Identificación</label>
                      <input value={formData.coacreditado.tipo_identificacion} onChange={e => updateField('coacreditado', 'tipo_identificacion', e.target.value)} style={st.input} placeholder="INE, Pasaporte..." />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 300 }}>
                      <label style={st.label}>Tipo Identificación <span style={{ fontWeight: 'normal', fontSize: 11, color: '#888' }}>(Exclusivo Santander)</span></label>
                      <select value={formData.coacreditado.tipo_identificacion_santander_id} onChange={e => updateField('coacreditado', 'tipo_identificacion_santander_id', e.target.value)} style={st.input}>
                        <option value="">-- Seleccionar --</option>
                        {tiposIdentificacionSantander.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={st.notaExclusiva}>Exclusivos para Banamex, HSBC, Santander y Scotiabank</div>
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={st.estaturaPesoBox}>
                  <div style={{ display: 'flex', gap: 35 }}>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                      <label style={st.label}>Estatura (cms)</label>
                      <input type="number" value={formData.coacreditado.estatura_cms} onChange={e => updateField('coacreditado', 'estatura_cms', e.target.value)} style={st.inputNumber} placeholder="ej: 170" />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                      <label style={st.label}>Estatura (mts)</label>
                      <input type="text" value={formData.coacreditado.estatura_mts} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} placeholder="automático" />
                    </div>
                    <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                      <label style={st.label}>Peso (kg)</label>
                      <input type="number" value={formData.coacreditado.peso_kg} onChange={e => updateField('coacreditado', 'peso_kg', e.target.value)} style={st.inputNumber} placeholder="ej: 75" />
                    </div>
                  </div>
                  <div style={st.notaExclusiva}>Exclusivo Afirme, Banamex, HSBC y Santander</div>
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                  <label style={st.label}>Núm. Dependientes</label>
                  <input type="number" value={formData.coacreditado.num_dependientes} onChange={e => updateField('coacreditado', 'num_dependientes', e.target.value)} style={st.inputNumber} placeholder="0" />
                </div>
              </div>
            </div>

            {/* DIRECCIÓN COACREDITADO */}
            <div style={st.card}>
              <h3 style={st.sectionTitle}>🏠 Dirección del Coacreditado</h3>
              
              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 480 }}>
                  <label style={st.label}>Calle</label>
                  <input value={formData.coacreditado.calle} onChange={e => updateField('coacreditado', 'calle', e.target.value)} style={st.input} disabled={formData.coacreditado.mismo_domicilio_titular} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Ext</label>
                  <input value={formData.coacreditado.no_ext} onChange={e => updateField('coacreditado', 'no_ext', e.target.value)} style={st.input} disabled={formData.coacreditado.mismo_domicilio_titular} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Int</label>
                  <input value={formData.coacreditado.no_int} onChange={e => updateField('coacreditado', 'no_int', e.target.value)} style={st.input} disabled={formData.coacreditado.mismo_domicilio_titular} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 110 }}>
                  <label style={st.label}>Código Postal</label>
                  <input
                    maxLength={5}
                    value={formData.coacreditado.codigo_postal}
                    onChange={e => updateField('coacreditado', 'codigo_postal', e.target.value.replace(/\D/g, ''))}
                    style={st.input}
                    placeholder="5 dígitos"
                    disabled={formData.coacreditado.mismo_domicilio_titular}
                  />
                </div>
              </div>

              <div style={st.grid3}>
                <div style={st.field}>
                  <label style={st.label}>Colonia</label>
                  <div style={st.inputConBoton}>
                    {coloniaEditable.coacreditado ? (
                      <input value={formData.coacreditado.colonia} onChange={e => updateField('coacreditado', 'colonia', e.target.value)} style={st.input} disabled={formData.coacreditado.mismo_domicilio_titular} />
                    ) : (
                      <select value={formData.coacreditado.colonia} onChange={e => updateField('coacreditado', 'colonia', e.target.value)} style={st.input} disabled={formData.coacreditado.mismo_domicilio_titular}>
                        <option value="">-- Seleccionar --</option>
                        {coloniasCoacreditado.map((c, i) => <option key={i} value={c.colonia}>{c.colonia}</option>)}
                        {formData.coacreditado.colonia && !coloniasCoacreditado.some(c => c.colonia === formData.coacreditado.colonia) && (
                          <option value={formData.coacreditado.colonia}>{formData.coacreditado.colonia}</option>
                        )}
                      </select>
                    )}
                    <button type="button" onClick={() => setColoniaEditable(prev => ({ ...prev, coacreditado: !prev.coacreditado }))} style={st.btnCalc} disabled={formData.coacreditado.mismo_domicilio_titular}>
                      {coloniaEditable.coacreditado ? 'Lista' : '✏️ Editar'}
                    </button>
                  </div>
                </div>
                <div style={st.field}>
                  <label style={st.label}>Ciudad/Población</label>
                  <input value={formData.coacreditado.ciudad} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Entidad Federativa</label>
                  <input value={formData.coacreditado.entidad_federativa} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>País</label>
                  <input value={formData.coacreditado.pais} onChange={e => updateField('coacreditado', 'pais', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
                  <label style={st.label}>Teléfono Casa</label>
                  <input maxLength={10} value={formData.coacreditado.telefono_casa} onChange={e => updateField('coacreditado', 'telefono_casa', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
                  <label style={st.label}>Teléfono Celular</label>
                  <input maxLength={10} value={formData.coacreditado.telefono_celular} onChange={e => updateField('coacreditado', 'telefono_celular', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 300 }}>
                  <label style={st.label}>Email</label>
                  <input type="email" value={formData.coacreditado.email} onChange={e => updateField('coacreditado', 'email', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 180 }}>
                  <label style={st.label}>Vive en Casa</label>
                  <select
                    value={formData.coacreditado.vive_en_casa}
                    onChange={e => updateField('coacreditado', 'vive_en_casa', e.target.value)}
                    style={st.input}
                    disabled={formData.coacreditado.mismo_domicilio_titular}
                  >
                    <option value="">-- Seleccionar --</option>
                    {VIVE_EN_CASA_OPCIONES.map(v => <option key={v} value={v}>{v}</option>)}
                  </select>
                </div>
              </div>


              <div style={st.grid4}>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Actual (Años)</label>
                  <input
                    type="number"
                    value={formData.coacreditado.antiguedad_domicilio_anos}
                    onChange={e => updateField('coacreditado', 'antiguedad_domicilio_anos', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                    disabled={formData.coacreditado.mismo_domicilio_titular}
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Actual (Meses)</label>
                  <input
                    type="number"
                    value={formData.coacreditado.antiguedad_domicilio_meses}
                    onChange={e => updateField('coacreditado', 'antiguedad_domicilio_meses', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                    disabled={formData.coacreditado.mismo_domicilio_titular}
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Anterior (Años)</label>
                  <input
                    type="number"
                    value={formData.coacreditado.antiguedad_domicilio_anterior_anos}
                    onChange={e => updateField('coacreditado', 'antiguedad_domicilio_anterior_anos', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                  />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad Domicilio Anterior (Meses)</label>
                  <input
                    type="number"
                    value={formData.coacreditado.antiguedad_domicilio_anterior_meses}
                    onChange={e => updateField('coacreditado', 'antiguedad_domicilio_anterior_meses', e.target.value)}
                    style={{ ...st.inputNumber, width: '50%' }}
                  />
                </div>
              </div>

            </div>
            {/* TRABAJO COACREDITADO */}
            {formData.coacreditado.participa_ingresos && (
            <div style={st.card}>
              <h3 style={st.sectionTitle}>💼 Datos del Trabajo del Coacreditado</h3>
              
              <div style={{ ...st.grid2, marginBottom: 16 }}>
                <div style={st.field}>
                  <label style={st.label}>Nombre de la Empresa</label>
                  <input value={formData.coacreditado.nombre_empresa} onChange={e => updateField('coacreditado', 'nombre_empresa', e.target.value)} style={st.input} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>RFC de la Empresa <span style={{ fontWeight: 'normal', color: '#888' }}>(opcional)</span></label>
                  <input maxLength={13} value={formData.coacreditado.rfc_empresa} onChange={e => updateField('coacreditado', 'rfc_empresa', e.target.value.toUpperCase())} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 480 }}>
                  <label style={st.label}>Calle</label>
                  <input value={formData.coacreditado.trabajo_calle} onChange={e => updateField('coacreditado', 'trabajo_calle', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Ext</label>
                  <input value={formData.coacreditado.trabajo_no_ext} onChange={e => updateField('coacreditado', 'trabajo_no_ext', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 90 }}>
                  <label style={st.label}>No. Int</label>
                  <input value={formData.coacreditado.trabajo_no_int} onChange={e => updateField('coacreditado', 'trabajo_no_int', e.target.value)} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 110 }}>
                  <label style={st.label}>Código Postal</label>
                  <input
                    maxLength={5}
                    value={formData.coacreditado.trabajo_codigo_postal}
                    onChange={e => updateField('coacreditado', 'trabajo_codigo_postal', e.target.value.replace(/\D/g, ''))}
                    style={st.input}
                    placeholder="5 dígitos"
                  />
                </div>
              </div>

              <div style={st.grid4}>
                <div style={st.field}>
                  <label style={st.label}>Colonia</label>
                  <div style={st.inputConBoton}>
                    {coloniaEditable.trabajoCoacreditado ? (
                      <input value={formData.coacreditado.trabajo_colonia} onChange={e => updateField('coacreditado', 'trabajo_colonia', e.target.value)} style={st.input} />
                    ) : (
                      <select value={formData.coacreditado.trabajo_colonia} onChange={e => updateField('coacreditado', 'trabajo_colonia', e.target.value)} style={st.input}>
                        <option value="">-- Seleccionar --</option>
                        {coloniasTrabajoCoacreditado.map((c, i) => <option key={i} value={c.colonia}>{c.colonia}</option>)}
                        {formData.coacreditado.trabajo_colonia && !coloniasTrabajoCoacreditado.some(c => c.colonia === formData.coacreditado.trabajo_colonia) && (
                          <option value={formData.coacreditado.trabajo_colonia}>{formData.coacreditado.trabajo_colonia}</option>
                        )}
                      </select>
                    )}
                    <button type="button" onClick={() => setColoniaEditable(prev => ({ ...prev, trabajoCoacreditado: !prev.trabajoCoacreditado }))} style={st.btnCalc}>
                      {coloniaEditable.trabajoCoacreditado ? 'Lista' : '✏️ Editar'}
                    </button>
                  </div>
                </div>
                <div style={st.field}>
                  <label style={st.label}>Ciudad/Municipio</label>
                  <input value={formData.coacreditado.trabajo_ciudad} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Entidad Federativa</label>
                  <input value={formData.coacreditado.trabajo_entidad_federativa} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6' }} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>País</label>
                  <input value={formData.coacreditado.trabajo_pais} onChange={e => updateField('coacreditado', 'trabajo_pais', e.target.value)} style={st.input} />
                </div>
              </div>

              <div style={st.rowPegado}>
                <div style={{ ...st.field, width: isMobile ? '100%' : 157 }}>
                  <label style={st.label}>Teléfono</label>
                  <input maxLength={10} value={formData.coacreditado.trabajo_telefono} onChange={e => updateField('coacreditado', 'trabajo_telefono', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 130 }}>
                  <label style={st.label}>Extensión</label>
                  <input value={formData.coacreditado.trabajo_extension} onChange={e => updateField('coacreditado', 'trabajo_extension', e.target.value.replace(/\D/g, ''))} style={st.input} />
                </div>
                <div style={{ ...st.field, width: isMobile ? '100%' : 160 }}>
                  <label style={st.label}>Fecha Ingreso</label>
                  <input type="date" value={formData.coacreditado.fecha_ingreso_trabajo} onChange={e => updateField('coacreditado', 'fecha_ingreso_trabajo', e.target.value)} style={st.input} />
                </div>
                <div style={st.field}>
                  <label style={st.label}>Antigüedad (Años/Meses)</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input type="text" value={formData.coacreditado.antiguedad_trabajo_anos} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6', width: isMobile ? '50%' : 160 }} placeholder="años" />
                    <input type="text" value={formData.coacreditado.antiguedad_trabajo_meses} readOnly style={{ ...st.input, backgroundColor: '#f3f4f6', width: isMobile ? '50%' : 160 }} placeholder="meses" />
                  </div>
                </div>
              </div>

              {!(parseInt(formData.coacreditado.antiguedad_trabajo_anos, 10) >= 2) && (
              <div style={{ marginTop: 24, paddingTop: 20, borderTop: '2px solid #e5e7eb' }}>
                <h4 style={{ fontSize: 16, fontWeight: 'bold', color: '#6b7280', marginBottom: 4 }}>Trabajo Anterior</h4>
                <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 0, marginBottom: 16 }}>Se requiere para cuando se tenga menos de 2 años en trabajo actual y sea Empleado</p>

                <div style={{ marginBottom: 16 }}>
                  <div style={st.field}>
                    <label style={st.label}>Nombre Empresa Anterior</label>
                    <input value={formData.coacreditado.nombre_empresa_anterior} onChange={e => updateField('coacreditado', 'nombre_empresa_anterior', e.target.value)} style={st.input} />
                  </div>
                </div>

                <div style={st.grid4}>
                  <div style={st.field}>
                    <label style={st.label}>Fecha Ingreso Trabajo Anterior</label>
                    <input type="date" value={formData.coacreditado.fecha_ingreso_trabajo_anterior} onChange={e => updateField('coacreditado', 'fecha_ingreso_trabajo_anterior', e.target.value)} style={st.input} />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Fecha Salida Trabajo Anterior</label>
                    <input type="date" value={formData.coacreditado.fecha_salida_trabajo_anterior} onChange={e => updateField('coacreditado', 'fecha_salida_trabajo_anterior', e.target.value)} style={st.input} />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Nombre Jefe Anterior</label>
                    <input value={formData.coacreditado.nombre_jefe_anterior} onChange={e => updateField('coacreditado', 'nombre_jefe_anterior', e.target.value)} style={st.input} />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Teléfono Empresa Anterior</label>
                    <input value={formData.coacreditado.telefono_trabajo_anterior} onChange={e => updateField('coacreditado', 'telefono_trabajo_anterior', e.target.value)} style={st.input} maxLength={10} />
                  </div>
                <div style={st.field}>
                    <label style={st.label}>Antigüedad Anterior (Años)</label>
                    <input
                      type="text"
                      value={formData.coacreditado.antiguedad_trabajo_anterior_anos}
                      readOnly
                      style={{ ...st.input, backgroundColor: '#f3f4f6', width: '70%' }}
                      placeholder="automático"
                    />
                  </div>
                  <div style={st.field}>
                    <label style={st.label}>Antigüedad Anterior (Meses)</label>
                    <input
                      type="text"
                      value={formData.coacreditado.antiguedad_trabajo_anterior_meses}
                      readOnly
                      style={{ ...st.input, backgroundColor: '#f3f4f6', width: '70%' }}
                      placeholder="automático"
                    />
                  </div>
                </div>
              </div>
              )}
            </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <button onClick={guardarCoacreditado} style={{ ...st.btn, ...st.btnPrimary }}>
                💾 Actualizar Coacreditado
              </button>
            </div>
          </div>
        )}

        {seccionActiva === 'referencias' && (
          <div>
            <div style={st.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={st.sectionTitle}>📞 Referencias Personales</h3>
                {formData.referencias.length < 4 && (
                  <button
                    onClick={agregarReferencia}
                    style={{ ...st.btn, ...st.btnPrimary, fontSize: 14, padding: '8px 16px' }}
                  >
                    ➕ Agregar Referencia
                  </button>
                )}
              </div>

              <div style={{ fontSize: 12, color: '#6b7280', marginTop: -12, marginBottom: 20, lineHeight: 1.6 }}>
                <div>Para Afirme se requieren 3 referencias personales o familiares</div>
                <div>Para Banamex se requieren 2 referencias para el titular y 2 referencias para el coacreditado (si este justifica ingresos)</div>
                <div>Para Banregio se requiere que sus referencias no sean familiares consanguíneos directos del titular y que no vivan en mismo domicilio que el titular</div>
                <div>Para Scotiabank, la Referencia #1 debe ser una persona que no sea familiar del titular, y la Referencia #2 debe ser una persona que sea familiar del titular y que no viva en el mismo domicilio que el titular</div>
              </div>

              {formData.referencias.map((ref, index) => (
                <div key={index} style={{ marginBottom: 32, padding: 20, border: '2px solid #e5e7eb', borderRadius: 8, backgroundColor: '#fafafa' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h4 style={{ fontSize: 18, fontWeight: 'bold', color: '#1a3a6e' }}>
                      Referencia #{ref.numero_referencia}
                      {ref.numero_referencia === 3 && <span style={{ color: '#f97316', marginLeft: 8 }}>(Exclusivo Afirme y Banamex)</span>}
                      {ref.numero_referencia === 4 && <span style={{ color: '#f97316', marginLeft: 8 }}>(Exclusivo Banamex)</span>}
                    </h4>
                    {index >= 2 && (
                      <button 
                        onClick={() => eliminarReferencia(index)} 
                        style={{ ...st.btn, backgroundColor: '#ef4444', color: 'white', fontSize: 12, padding: '6px 12px' }}
                      >
                        🗑️ Eliminar
                      </button>
                    )}
                  </div>

                  <div style={st.grid3}>
                    <div style={st.field}>
                      <label style={st.label}>Nombres *</label>
                      <input 
                        value={ref.nombres} 
                        onChange={e => updateReferencia(index, 'nombres', e.target.value)} 
                        style={st.input} 
                      />
                    </div>
                    <div style={st.field}>
                      <label style={st.label}>Apellido Paterno *</label>
                      <input 
                        value={ref.apellido_paterno} 
                        onChange={e => updateReferencia(index, 'apellido_paterno', e.target.value)} 
                        style={st.input} 
                      />
                    </div>
                    <div style={st.field}>
                      <label style={st.label}>Apellido Materno</label>
                      <input 
                        value={ref.apellido_materno} 
                        onChange={e => updateReferencia(index, 'apellido_materno', e.target.value)} 
                        style={st.input} 
                      />
                    </div>
                  </div>

                  <div style={st.grid3}>
                    <div style={st.field}>
                      <label style={st.label}>Teléfono Celular *</label>
                      <input 
                        maxLength={10}
                        value={ref.telefono_celular} 
                        onChange={e => updateReferencia(index, 'telefono_celular', e.target.value.replace(/\D/g, ''))} 
                        style={st.input} 
                        placeholder="10 dígitos"
                      />
                    </div>
                    <div style={st.field}>
                      <label style={st.label}>Teléfono Casa</label>
                      <input 
                        maxLength={10}
                        value={ref.telefono_casa} 
                        onChange={e => updateReferencia(index, 'telefono_casa', e.target.value.replace(/\D/g, ''))} 
                        style={st.input} 
                        placeholder="10 dígitos"
                      />
                    </div>
                    <div style={st.field}>
                      <label style={st.label}>Teléfono Oficina</label>
                      <input 
                        maxLength={10}
                        value={ref.telefono_oficina} 
                        onChange={e => updateReferencia(index, 'telefono_oficina', e.target.value.replace(/\D/g, ''))} 
                        style={st.input} 
                        placeholder="10 dígitos"
                      />
                    </div>
                  </div>

                  {/* Campos específicos por banco */}
                  <div style={st.grid3}>
                    {/* Parentesco - Afirme, Banregio, Scotiabank */}
                    {(ref.tipo !== 'extra') && (
                      <div style={st.field}>
                        <label style={st.label}>
                          Parentesco
                          <span style={{ fontSize: 11, color: '#6b7280', marginLeft: 4 }}>
                            (Afirme, Banregio, Scotiabank)
                          </span>
                        </label>
                        <input 
                          value={ref.parentesco} 
                          onChange={e => updateReferencia(index, 'parentesco', e.target.value)} 
                          style={st.input} 
                        />
                      </div>
                    )}

                    {/* Años de conocerlo - Solo Scotiabank */}
                    {(ref.tipo !== 'extra') && (
                      <div style={st.field}>
                        <label style={st.label}>
                          Años de Conocerlo
                          <span style={{ fontSize: 11, color: '#6b7280', marginLeft: 4 }}>(Solo Scotiabank)</span>
                        </label>
                        <input 
                          type="number"
                          maxLength={2}
                          value={ref.anos_conocerlo} 
                          onChange={e => updateReferencia(index, 'anos_conocerlo', e.target.value)} 
                          style={st.inputNumber} 
                        />
                      </div>
                    )}

                    {/* Email - Solo HSBC */}
                    {(ref.tipo !== 'extra') && (
                      <div style={st.field}>
                        <label style={st.label}>
                          Email
                          <span style={{ fontSize: 11, color: '#6b7280', marginLeft: 4 }}>(Solo HSBC)</span>
                        </label>
                        <input 
                          type="email"
                          value={ref.email} 
                          onChange={e => updateReferencia(index, 'email', e.target.value)} 
                          style={st.input} 
                          placeholder="correo@ejemplo.com"
                        />
                      </div>
                    )}
                  </div>

                  {/* Dirección completa - Solo Banregio (no es obligatorio) */}
                  {(ref.tipo !== 'extra') && (
                    <div style={{ marginTop: 12 }}>
                      <div style={st.field}>
                        <label style={st.label}>
                          Dirección Completa
                          <span style={{ fontSize: 11, color: '#6b7280', marginLeft: 4 }}>(Solo Banregio - Opcional)</span>
                        </label>
                        <input 
                          value={ref.direccion_completa} 
                          onChange={e => updateReferencia(index, 'direccion_completa', e.target.value)} 
                          style={st.input} 
                          placeholder="Calle, número, colonia, ciudad..."
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <button onClick={guardarReferencias} style={{ ...st.btn, ...st.btnPrimary }}>
                💾 Actualizar Referencias
              </button>
            </div>
          </div>
        )}

        {seccionActiva === 'banco_afirme' && (
          <BancoAfirme
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'banco_banamex' && (
          <BancoBanamex
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'banco_banorte' && (
          <BancoBanorte
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'banco_banregio' && (
          <BancoBanregio
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'banco_hsbc' && (
          <BancoHSBC
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'banco_santander' && (
          <BancoSantander
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'banco_scotiabank' && (
          <BancoScotiabank
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        {seccionActiva === 'status' && (
          <StatusProspecto
            prospectoId={prospectoActual?.id}
            formData={formData}
            setFormData={setFormData}
          />
        )}
        </fieldset>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 24 }}>
          <button onClick={() => setView('lista')} style={{ ...st.btn, ...st.btnCancel }}>
            Cerrar Prospecto
          </button>
        </div>
      </div>
    );
  }

  return null;
}
